// extracted by mini-css-extract-plugin
module.exports = {"deviceListTable":"DevicesList_deviceListTable__3rTo5","deviceListTableBody":"DevicesList_deviceListTableBody__34FZI","deviceIdItemAction":"DevicesList_deviceIdItemAction__2knav"};